/**
 * Mensaje de error para mostrar en pantalla.
 * En 4xx el backend deja el motivo de dominio en `error` (y en `message` un título genérico como
 * "Error de validación"); en 5xx `error` trae el detalle técnico (SQL, pymysql), así que se usa
 * el `message` simplificado. Nunca muestra el mensaje técnico de axios.
 * @param {Object} failure Error de la consulta o mutación.
 * @param {string} fallback Texto de respaldo desde `constants/`.
 * @returns {string} Mensaje para el usuario.
 */
export const getApiErrorMessage = (failure, fallback = '') => {
  const response = failure?.response;
  const data = response?.data;
  if (!data) return fallback;
  const isClientError = response.status >= 400 && response.status < 500;
  const domainDetail = isClientError && typeof data.error === 'string' ? data.error : '';
  return domainDetail || data.message || fallback;
};
